var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as THREE from 'three';
import { OrbFactory } from '../../orbs/OrbFactory';
import * as ObjectCreation from '../creation/ObjectCreation';
import { AbilityMode, getAbilityList } from '../hud/AbilityHUD';
import { global } from '../../core/GlobalState';
import * as SelectionUtils from '../interaction/SelectionUtils';
import * as DragHandler from '../interaction/DragHander';
import * as ConnectionUtils from '../connections/InteractiveConnectionUtils';
import * as EntryWarp from '../interaction/EntryWarp';
import * as AttractionSystem from '../physics/AttractionSystem';
import * as SpraySystem from '../physics/SpraySystem';
import { OrbConnectionManager } from '../connections/OrbConnectionManager';
import { getEffectiveRadius } from '../connections/OrbRelationshipUtils';
import { Orb } from '../../orbs/Orb';
import SceneManager from '../../core/SceneManager';
import { buildWorldFromOrb } from '../creation/worlds/JsonWorldBuilder';
import { openModal, closeModal } from '../ui/ModalUtils';
import { OrbTypes } from '../../orbs/OrbTypes';
import { summonedOrbitController } from './SummonedOrbitController';
import { playerOrbitController } from '../movement/PlayerOrbitController';
import { expandOrbNested } from './nestedExpansion/NestedOrbExpansion';
import { beginUiOverlay, endUiOverlay } from '../../core/AppStateManager';
import * as Portals from '../portals/SceneSwitching';
import { World } from '../creation/worlds/World';
import { registerScenePolicy } from '../../core/ScenePolicies';
import { addWorldBoundarySphere } from '../creation/worlds/WorldBuilderHelpers';
import { playerManager } from '../../core/player/PlayerManager';
import { computeRingLayout, getRegisteredRingChildren, getRingParentPresentationMode, setRingParentPresentationMode, setRingChildPresentationMode, RingOrbitAnimator, registerRingChild, } from '../../utils/RingLayout';
import { CONNECTION_PRESENTATION_ORDER, DEFAULT_PRESENTATION_ARROW_PROFILE, getPresentationProfileName, } from '../connections/ConnectionPresentation';
const ORB_WORLD_RADIUS = 24000;
const JSON_EXPANSION_METADATA_KEY = '__jsonExpansionChildren';
const JSON_EXPANSION_ANIMATOR_KEY = '__jsonExpansionAnimator';
export class AbilitySystem {
    constructor() {
        this.lastActivateAt = 0;
        this.resizeOutlineTimeout = null;
        this.pendingMergeSelection = null;
        console.log('[AbilitySystem] Ability system booting');
        console.log('[AbilitySystem] Available abilities enumerated', {
            count: getAbilityList().length,
        });
    }
    //TODO see if these handle methods can be even fruther combiend so that everything is under once switch statmentm rather than handleMouseDown/Up NEEDING THEIR OWN CONDITIONALs
    handleAbility(mode, eventCoords) {
        console.log(`${AbilityMode[mode]} (${mode})`);
        switch (mode) {
            case AbilityMode.CreateOrb:
                this.createCustomOrb();
                break;
            //case AbilityMode.CreateBlackhole: this.createBlackhole(); break;
            case AbilityMode.CreateSystemPortal:
                this.createSystemPortal();
                break;
            case AbilityMode.ShootProjectile:
                this.shootProjectile();
                break;
            case AbilityMode.DeleteObject:
                this.deleteObject(eventCoords);
                break;
            case AbilityMode.InspectObject:
                this.inspectObject(eventCoords);
                break;
            case AbilityMode.WarpToOrb:
                this.warpToOrb(eventCoords);
                break;
            case AbilityMode.EnterOrb:
                this.enterOrb(eventCoords);
                break;
            case AbilityMode.SummonOrbs:
                this.summonOrbs();
                break;
            case AbilityMode.GenerateSphericalArrangement:
                this.generateSphericalArrangement();
                break;
            //new ones
            case AbilityMode.CreateConnection:
                this.createConnection(eventCoords);
                break;
            case AbilityMode.ToggleConnectionPresentation:
                this.toggleConnectionPresentation(eventCoords);
                break;
            //case AbilityMode.AttractSelectedOrbType: this.attractSelectedOrbType(); break;
            case AbilityMode.AttractAllOrbs:
                AttractionSystem.attractAllOrbs();
                break;
            case AbilityMode.OrbitOrb:
                this.orbitOrb(eventCoords);
                break;
            case AbilityMode.ExpandNestedOrbs:
                void this.expandNestedOrbs(eventCoords);
                break;
            case AbilityMode.ActivateOrb:
                this.activateOrb(eventCoords);
                break;
            //case AbilityMode.CastSpell: this.castSpell(eventCoords); break;
            //case AbilityMode.HookOrb: this.hookOrb(eventCoords); break;
            //case AbilityMode.UserSelectOrb: this.userSelectOrb(eventCoords); break;
            case AbilityMode.WarpDimension:
                this.warpDimension();
                break;
            case AbilityMode.AutoflyMode:
                this.toggleAutofly();
                break;
            case AbilityMode.RepelOrbs:
                this.repelOrbs();
                break;
            case AbilityMode.OpenCodeWorkbench:
                this.openCodeWorkbench();
                break;
            case AbilityMode.OpenCommandConsole:
                this.openCommandConsole();
                break;
            //case AbilityMode.ApplyDagLayout: this.applyDagLayout(); break;
            case AbilityMode.GrowSelectedOrb:
                this.growSelectedOrb(eventCoords);
                break;
            case AbilityMode.ShrinkSelectedOrb:
                this.shrinkSelectedOrb(eventCoords);
                break;
            case AbilityMode.CloneOrb:
                this.cloneOrb(eventCoords);
                break;
            case AbilityMode.RandomWarp:
                this.randomWarp();
                break;
            case AbilityMode.OrbSetInversion:
                this.toggleOrbSetInversion();
                break;
            case AbilityMode.SplitOrb:
                void this.splitOrb(eventCoords);
                break;
            case AbilityMode.MergeOrbs:
                this.mergeOrbs(eventCoords);
                break;
            case AbilityMode.GlobalOrbSearch:
                this.openGlobalOrbSearch();
                break;
            default:
                console.warn(`Unhandled ability: ${mode}`);
        }
    }
    //looking to make these more general
    // AbilitySystem.ts
    handleMouseDown(mode, eventCoords) {
        switch (mode) {
            case AbilityMode.MoveObject:
                DragHandler.startMoveObjectDrag();
                break;
            case AbilityMode.AttractAllOrbs:
                global.attractAllMode = true;
                break;
            case AbilityMode.CreateConnection:
                ConnectionUtils.startConnectDrag(eventCoords);
                break;
        }
    }
    handleMouseUp(mode, eventCoords) {
        switch (mode) {
            case AbilityMode.MoveObject:
                DragHandler.releaseMoveObjectDrag();
                break;
            case AbilityMode.AttractAllOrbs:
                global.attractAllMode = false;
                break;
            case AbilityMode.CreateConnection:
                ConnectionUtils.endConnectDrag(eventCoords);
                break;
        }
    }
    // Call this on pointer/mouse move if CreateConnection is active
    handleMouseMove(mode, eventCoords) {
        if (mode === AbilityMode.CreateConnection) {
            ConnectionUtils.updateConnectDrag(eventCoords);
        }
    }
    // --- abilities below ---
    createBlackhole() {
        const orb = OrbFactory.createOrbByType('BLACKHOLE', 'Blackhole');
        orb.setPosition(global.camera.position.clone());
        orb.addToScene(global.scene);
    }
    createSystemPortal() {
        const targetScene = 'system';
        global.worldRegistry.ensureScene(targetScene);
        const orb = OrbFactory.createOrbByType('SYSTEM_ORB', 'Return to System');
        orb.orbConfig = Object.assign(Object.assign({}, orb.orbConfig), { isPortal: true, portalLayer: 'inner', portalTargetSceneName: targetScene, portalResolution: 512, portalCameraFOV: 70 });
        orb.setPosition(global.camera.position.clone());
        orb.addToScene(global.scene);
        global.chat.addMessage('🌀 System portal anchored');
    }
    shootProjectile() {
        const position = new THREE.Vector3();
        global.camera.getWorldPosition(position);
        const direction = global.camera.getWorldDirection(new THREE.Vector3());
        const orb = OrbFactory.createOrbByType("CLASSIC", "Orb Projectile");
        orb.setPosition(position);
        orb.addVelocity(direction.multiplyScalar(20));
        orb.addToScene(global.scene);
    }
    deleteObject(eventCoords) {
        const object = SelectionUtils.getTargetObject(eventCoords);
        if (!object || !object.parent)
            return;
        const group = object.parent;
        const orb = global.orbManager.getOrb(group.uuid);
        if (orb && orb.group) {
            const connectionManager = OrbConnectionManager.getInstance();
            connectionManager.teardownConnectionsFor(orb);
            global.orbManager.hardRemoveOrb(orb.group.uuid);
        }
        else {
            global.orbManager.removeOrb(group.uuid, global.scene);
            group.remove(object);
        }
    }
    inspectObject(eventCoords) {
        var _a;
        const object = this.resolveInteractionObject(eventCoords, { allowLocalClientOrbOnBounce: false });
        if (!object)
            return;
        global.currentObject = object;
        SelectionUtils.applyOutlineToObject(object);
        //need to fix the chat display in this, it used to be explicitly done in setSelectedObject        
        //should be able to make a call to global.currentObject and check if it is an orb and if so add it to the chat
        // Try to get the parent group (which should be the Orb's THREE.Group)
        const parent = object.parent;
        if (!parent)
            return;
        // Lookup orb from OrbManager
        const orb = global.orbManager.getOrb(parent.uuid);
        if (!orb) {
            global.chat.addMessage("No orb found for selected object.");
            return;
        }
        (_a = playerManager.local) === null || _a === void 0 ? void 0 : _a.syncClientOrbStateNow();
        global.chat.addMessage(orb.displayJson());
    }
    warpToOrb(eventCoords) {
        const object = this.resolveInteractionObject(eventCoords, { allowLocalClientOrbOnBounce: false });
        if (!object)
            return;
        global.currentObject = object;
        SelectionUtils.applyOutlineToObject(object);
        const orb = this.findOwningOrb(object);
        if (!orb) {
            global.chat.addMessage('⚠️ Unable to locate orb for warp.');
            return;
        }
        EntryWarp.warpToPoint(() => {
            var _a;
            global.chat.addMessage(`✨ Warped to ${orb.labelText || orb.orbType || ((_a = orb.group) === null || _a === void 0 ? void 0 : _a.uuid)}`);
        });
    }
    enterOrb(eventCoords) {
        var _a;
        const object = this.resolveInteractionObject(eventCoords, { allowLocalClientOrbOnBounce: true });
        if (!object)
            return;
        global.currentObject = object;
        SelectionUtils.applyOutlineToObject(object);
        const orb = this.findOwningOrb(object);
        if (!orb) {
            global.chat.addMessage('⚠️ Unable to locate orb for entry.');
            return;
        }
        (_a = playerManager.local) === null || _a === void 0 ? void 0 : _a.syncClientOrbStateNow();
        EntryWarp.warpToPoint(() => {
            var _a, _b;
            let arrivedScene = null;
            if (((_a = orb.orbConfig) === null || _a === void 0 ? void 0 : _a.isPortal) && ((_b = orb.orbConfig) === null || _b === void 0 ? void 0 : _b.portalTargetSceneName)) {
                Portals.enterPortal(orb);
            }
            else {
                const { sceneName, label } = this.ensureOrbWorldScene(orb);
                Portals.switchScene(sceneName, { unloadTwoHops: false });
                global.chat.addMessage(`🌐 Entering orb world ${label}`);
                arrivedScene = label;
            }
            if (arrivedScene) {
                global.chat.addMessage(`🛰️ Arrived inside ${arrivedScene}`);
            }
            SelectionUtils.clearOutline();
            global.currentObject = null;
        });
    }
    generateSphericalArrangement() {
        const orb = OrbFactory.createOrbByType("SPHERE_ORB", "∞");
        orb.setPosition(global.camera.position.clone());
        const group = orb.createOrb();
        const arrangement = ObjectCreation.createOrbSphericalArrangement(1000, 800, global.camera.position.clone(), group);
        arrangement.forEach(child => global.scene.add(child));
    }
    summonOrbs() {
        const type = global.hudLastSelectedOrbType;
        if (!type || type === '—') {
            global.chat.addMessage('⚠️ Select an orb first to summon its kin.');
            return;
        }
        const manager = SceneManager.getInstance();
        const sceneName = manager.getCurrentSceneName();
        const playerPos = global.controls.getObject().position.clone();
        const orbs = global.orbManager.getOrbsByType(type).filter(orb => {
            const orbScene = global.orbManager.getSceneForOrb(orb);
            return !orbScene || orbScene === sceneName;
        });
        if (orbs.length === 0) {
            global.chat.addMessage(`ℹ️ No orbs of type ${type} found in this scene.`);
            return;
        }
        summonedOrbitController.clear();
        const items = [];
        const placedOrbs = [];
        let maxRadius = 0;
        orbs.forEach((orb, index) => {
            var _a, _b;
            if (!orb.group) {
                orb.createOrb();
            }
            const group = orb.group;
            if (!group) {
                console.warn('[AbilitySystem] SummonOrbs skipped orb without group', { index, type });
                return;
            }
            const radius = (_b = (_a = orb.orbConfig) === null || _a === void 0 ? void 0 : _a.radius) !== null && _b !== void 0 ? _b : 160;
            maxRadius = Math.max(maxRadius, radius);
            items.push({ id: group.uuid, radius });
            placedOrbs.push(orb);
        });
        const layout = computeRingLayout(items, {
            centre: playerPos,
            minRadius: Math.max(1000, maxRadius * 3.8),
            minSeparation: maxRadius * 1.4,
            startAngle: Math.PI * 0.5,
        });
        layout.placements.forEach((placement, index) => {
            const orb = placedOrbs[index];
            if (!orb)
                return;
            global.orbManager.addOrbToScene(orb, sceneName);
            orb.setPosition(placement.position.clone());
        });
        summonedOrbitController.configure(Object.assign(Object.assign({}, layout), { placements: layout.placements.map((placement, index) => {
                var _a, _b, _c;
                return (Object.assign(Object.assign({}, placement), { id: (_c = (_b = (_a = placedOrbs[index]) === null || _a === void 0 ? void 0 : _a.group) === null || _b === void 0 ? void 0 : _b.uuid) !== null && _c !== void 0 ? _c : placement.id }));
            }) }), {
            angularVelocityBase: 0.65,
            angularVelocityStep: 0.04,
        });
        global.chat.addMessage(`🪐 Summoned ${orbs.length} ${type} orbs into orbit.`);
    }
    // new abilities below, many will not work:
    createConnection(eventCoords) {
        var _a, _b;
        const object = SelectionUtils.getTargetObject(eventCoords);
        // Clicked “off” -> clear selection & outlines
        if (!object || !object.parent) {
            global.connectSelection = null;
            SelectionUtils.clearOutline();
            global.chat.addMessage('🔶 Connection selection cleared.');
            return;
        }
        const orb = global.orbManager.getOrb(object.parent.uuid);
        if (!orb) {
            global.connectSelection = null;
            SelectionUtils.clearOutline();
            global.chat.addMessage('🔶 Connection selection cleared.');
            return;
        }
        // First endpoint
        if (!global.connectSelection) {
            global.connectSelection = orb;
            SelectionUtils.applyOutlineToObject(object, '0xffd400', 3);
            global.chat.addMessage('🟡 First orb selected. Click another orb to connect, or click empty space to clear.');
            return;
        }
        // Clicked the same orb again -> cancel
        if (((_a = global.connectSelection.group) === null || _a === void 0 ? void 0 : _a.uuid) === ((_b = orb.group) === null || _b === void 0 ? void 0 : _b.uuid)) {
            global.connectSelection = null;
            SelectionUtils.clearOutline();
            global.chat.addMessage('🔶 Connection selection cleared.');
            return;
        }
        // Connect A -> B
        const cm = OrbConnectionManager.getInstance();
        if (!cm.has(global.connectSelection, orb, undefined, 'edge')) {
            cm.setRelationshipState({
                a: global.connectSelection,
                b: orb,
                orbit: false,
                arrow: true,
                hideChild: false,
                targetVisibility: 'preserve',
            });
            global.chat.addMessage('🔗 Connected orbs.');
        }
        else {
            global.chat.addMessage('ℹ️ Already connected.');
        }
        // IMPORTANT: reset visual + state so the next click starts a fresh A
        SelectionUtils.clearOutline();
        global.connectSelection = null;
    }
    //==========================================================================
    attractSelectedOrbType() {
        console.log("Attracting selected orb type...");
        // TODO: Get type from selected orb, then apply force to nearby orbs
    }
    orbitOrb(eventCoords) {
        var _a, _b, _c;
        const object = SelectionUtils.setSelectedObject(eventCoords);
        if (!object || !object.parent) {
            if (global.orbitingTarget || playerOrbitController.isActive()) {
                this.cancelOrbit('🛰️ Orbit disengaged.', { unlockCamera: true });
            }
            else {
                global.chat.addMessage('⚠️ Click an orb to establish an orbit.');
            }
            return;
        }
        const orb = global.orbManager.getOrb(object.parent.uuid);
        if (!orb || !orb.group) {
            this.cancelOrbit('⚠️ Selected object is not orbit-capable.');
            return;
        }
        const currentTarget = global.orbitingTarget;
        const isSameTarget = !!currentTarget && ((_a = currentTarget.group) === null || _a === void 0 ? void 0 : _a.uuid) === orb.group.uuid;
        if (isSameTarget) {
            const label = this.describeOrbTarget(orb);
            this.cancelOrbit(`🛑 Orbit cancelled around ${label}.`, { unlockCamera: true });
            return;
        }
        const startPosition = global.controls.getObject().position.clone();
        const orbPosition = orb.group.position.clone();
        const pointerPoint = eventCoords
            ? SelectionUtils.worldPointFromPointer(eventCoords.x, eventCoords.y)
            : orbPosition.clone();
        let entryDirection = pointerPoint.clone().sub(orbPosition);
        if (entryDirection.lengthSq() < 1e-4) {
            entryDirection = global.camera.position.clone().sub(orbPosition);
        }
        if (entryDirection.lengthSq() < 1e-4) {
            entryDirection.set(0, 1, 0);
        }
        entryDirection.normalize();
        const orbitRadius = Math.max(((_c = (_b = orb.orbConfig) === null || _b === void 0 ? void 0 : _b.radius) !== null && _c !== void 0 ? _c : 100) * 3, 15);
        const entryPoint = orbPosition.clone().add(entryDirection.clone().multiplyScalar(orbitRadius));
        const planeNormal = this.deriveOrbitPlane(entryDirection);
        const controlPoint = this.computeApproachControlPoint(startPosition, entryPoint, planeNormal);
        const approachDistance = startPosition.distanceTo(entryPoint);
        const approachDuration = this.estimateApproachDuration(approachDistance);
        const orbitSpeed = this.estimateOrbitSpeed(orbitRadius);
        playerOrbitController.cancel({ announce: false, unlockCamera: false });
        SelectionUtils.clearOutline();
        SelectionUtils.applyOutlineToObject(object, 0x4caf50, 4);
        playerOrbitController.begin({
            orb,
            entryPoint,
            controlPoint,
            planeNormal,
            orbitRadius,
            orbitSpeed,
            approachDuration,
            unlockOnExit: true,
        });
        const label = this.describeOrbTarget(orb);
        if (currentTarget) {
            global.chat.addMessage(`🔁 Switching orbit to ${label}.`);
        }
        else {
            global.chat.addMessage(`🌀 Approaching ${label} to enter orbit.`);
        }
    }
    cancelOrbit(message, options = {}) {
        const hadOrbit = !!global.orbitingTarget || playerOrbitController.isActive();
        playerOrbitController.cancel({ announce: false, unlockCamera: options.unlockCamera });
        global.orbitingTarget = null;
        SelectionUtils.clearOutline();
        if (message) {
            global.chat.addMessage(message);
        }
        else if (hadOrbit) {
            global.chat.addMessage('🛰️ Orbit disengaged.');
        }
    }
    deriveOrbitPlane(radialDirection) {
        const worldUp = new THREE.Vector3(0, 1, 0);
        const planeNormal = new THREE.Vector3().crossVectors(radialDirection, worldUp);
        if (planeNormal.lengthSq() < 1e-4) {
            const cameraForward = new THREE.Vector3();
            global.camera.getWorldDirection(cameraForward);
            planeNormal.crossVectors(radialDirection, cameraForward);
        }
        if (planeNormal.lengthSq() < 1e-4) {
            planeNormal.set(0, 1, 0);
        }
        return planeNormal.normalize();
    }
    computeApproachControlPoint(start, entryPoint, planeNormal) {
        const midpoint = start.clone().lerp(entryPoint, 0.5);
        const bend = planeNormal.clone().multiplyScalar(start.distanceTo(entryPoint) * 0.25);
        return midpoint.add(bend);
    }
    estimateApproachDuration(distance) {
        return THREE.MathUtils.clamp(distance / 5200, 0.08, 0.28);
    }
    estimateOrbitSpeed(radius) {
        return THREE.MathUtils.clamp(radius * 5.5, 960, 5400);
    }
    describeOrbTarget(orb) {
        return orb.labelText || orb.orbType || 'orb';
    }
    expandNestedOrbs(eventCoords) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            console.log("Expanding nested orb structure...");
            const object = SelectionUtils.setSelectedObject(eventCoords);
            if (!object || !object.parent) {
                global.chat.addMessage('⚠️ No object selected for expansion.');
                return;
            }
            SelectionUtils.flashOutlineForObject(object);
            const orb = global.orbManager.getOrb(object.parent.uuid);
            if (!orb) {
                global.chat.addMessage('⚠️ Could not locate an orb to expand.');
                return;
            }
            let nestedCreated = 0;
            const nestedConfig = (_a = orb.orbConfig) === null || _a === void 0 ? void 0 : _a.nestedExpansion;
            if (nestedConfig === null || nestedConfig === void 0 ? void 0 : nestedConfig.enabled) {
                try {
                    const result = yield expandOrbNested(orb);
                    nestedCreated = result.created.length;
                    if (nestedCreated > 0) {
                        global.chat.addMessage(`✨ Generated ${nestedCreated} nested orbs.`);
                        return;
                    }
                }
                catch (error) {
                    console.error('[AbilitySystem] Failed to expand nested orb', error);
                }
            }
            const jsonResult = yield this.expandJsonDataChildren(orb);
            if (jsonResult.created.length > 0) {
                global.chat.addMessage(`✨ Generated ${jsonResult.created.length} data-driven child orbs.`);
                return;
            }
            if (nestedConfig === null || nestedConfig === void 0 ? void 0 : nestedConfig.enabled) {
                if (nestedCreated > 0) {
                    // Should not happen due to early return, but guard just in case
                    global.chat.addMessage('ℹ️ No additional child orbs were generated from JSON data.');
                    return;
                }
                global.chat.addMessage('ℹ️ No child orbs were generated from the nested configuration or JSON data.');
                return;
            }
            switch (jsonResult.reason) {
                case 'noData':
                case 'noEntries':
                    global.chat.addMessage('ℹ️ This orb has no JSON data to expand.');
                    break;
                case 'noGroup':
                    global.chat.addMessage('⚠️ Unable to expand this orb because it has not been instantiated in the scene yet.');
                    break;
                case 'noScene':
                    global.chat.addMessage('⚠️ Unable to determine a scene for spawning child orbs.');
                    break;
                default:
                    global.chat.addMessage('ℹ️ No child orbs were generated.');
                    break;
            }
        });
    }
    expandJsonDataChildren(parent, options = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function* () {
            const rawData = parent.jsonData;
            if (!rawData || typeof rawData !== 'object') {
                return { created: [], reason: 'noData' };
            }
            const entries = this.extractJsonEntries(rawData);
            if (entries.length === 0) {
                return { created: [], reason: 'noEntries' };
            }
            if (!parent.group) {
                try {
                    parent.createOrb();
                }
                catch (error) {
                    console.warn('[AbilitySystem] Parent orb lacks a render group for JSON expansion.', error);
                    return { created: [], reason: 'noGroup' };
                }
            }
            if (!parent.group) {
                return { created: [], reason: 'noGroup' };
            }
            const sceneManager = SceneManager.getInstance();
            const sceneName = (_a = global.orbManager.getSceneForOrb(parent)) !== null && _a !== void 0 ? _a : sceneManager.getCurrentSceneName();
            if (!sceneName) {
                return { created: [], reason: 'noScene' };
            }
            const scene = sceneManager.getScene(sceneName);
            const centre = parent.group.position.clone();
            const baseRadius = Math.max(parent.getEffectiveRadius(), 120);
            const childRadiusFallback = Math.max(baseRadius * 0.45, 80);
            const spawnStyle = (_b = options.spawnStyle) !== null && _b !== void 0 ? _b : 'ring';
            const userData = parent.group.userData;
            const existingAnimator = userData[JSON_EXPANSION_ANIMATOR_KEY];
            if (existingAnimator instanceof RingOrbitAnimator) {
                existingAnimator.dispose();
            }
            const shouldRingLayout = spawnStyle === 'ring';
            const shouldSpray = spawnStyle === 'spray';
            let animator;
            const items = [];
            if (shouldRingLayout) {
                animator = new RingOrbitAnimator();
                userData[JSON_EXPANSION_ANIMATOR_KEY] = animator;
            }
            else {
                delete userData[JSON_EXPANSION_ANIMATOR_KEY];
            }
            const created = [];
            const metadata = [];
            const typeCandidates = [];
            if (parent.orbType) {
                typeCandidates.push(parent.orbType);
            }
            typeCandidates.push('CLASSIC');
            for (const [key, rawValue] of entries) {
                let child;
                const label = this.buildJsonChildLabel(key, rawValue);
                const childData = this.buildJsonChildData(key, rawValue, parent);
                for (const candidate of typeCandidates) {
                    child = OrbFactory.createOrbByType(candidate, label, childData);
                    if (child)
                        break;
                }
                if (!child) {
                    console.warn('[AbilitySystem] Unable to create orb for JSON entry', { key, rawValue });
                    continue;
                }
                try {
                    child.createOrb();
                }
                catch (error) {
                    console.warn('[AbilitySystem] Failed to initialise child orb for JSON entry', { key, error });
                    continue;
                }
                if (!child.group) {
                    console.warn('[AbilitySystem] Child orb missing group after creation', { key });
                    continue;
                }
                if (shouldSpray) {
                    const parentRadius = parent.getEffectiveRadius();
                    const desiredRadius = parentRadius > 0 ? Math.max(parentRadius * 0.5, 1) : childRadiusFallback;
                    child.applyRadiusChange(desiredRadius);
                }
                if (shouldRingLayout) {
                    const radius = (_e = (_d = (_c = child.orbConfig) === null || _c === void 0 ? void 0 : _c.radius) !== null && _d !== void 0 ? _d : child.getEffectiveRadius()) !== null && _e !== void 0 ? _e : childRadiusFallback;
                    items.push({
                        id: child.group.uuid,
                        radius: radius > 0 ? radius : childRadiusFallback,
                    });
                }
                metadata.push({ key, childId: child.group.uuid });
                created.push(child);
            }
            if (created.length === 0) {
                return { created: [], reason: 'noChildren' };
            }
            const manager = OrbConnectionManager.getInstance();
            if (shouldRingLayout && animator) {
                const maxChildRadius = items.reduce((max, item) => Math.max(max, item.radius), 0);
                const layout = computeRingLayout(items, {
                    centre,
                    minRadius: Math.max(baseRadius * 2.2, baseRadius + maxChildRadius * 1.6, childRadiusFallback * 3),
                    minSeparation: Math.max(maxChildRadius * 1.4, baseRadius * 0.8, childRadiusFallback * 1.2),
                    startAngle: Math.PI * 0.5,
                });
                setRingParentPresentationMode(parent, 'orbit');
                layout.placements.forEach((placement, index) => {
                    var _a, _b, _c;
                    const child = created[index];
                    if (!child || !child.group)
                        return;
                    child.setPosition(placement.position.clone());
                    global.orbManager.addOrbToScene(child, sceneName);
                    if (!parent.childOrbsManaged.includes(child)) {
                        parent.childOrbsManaged.push(child);
                    }
                    if (parent.group) {
                        parent.addDependent(child.group.uuid);
                        child.addDependency(parent.group.uuid);
                    }
                    const binding = {
                        object: child.group,
                        placement,
                        centreProvider: () => (parent.group ? parent.group.position.clone() : placement.orbitCentre.clone()),
                    };
                    animator.add(binding);
                    registerRingChild({ parent, child, animator, binding });
                    setRingChildPresentationMode(parent, child, 'orbit');
                    manager.setRelationshipState({ a: parent, b: child, mode: 'orbit' });
                    const childUserData = child.group.userData;
                    const metadataEntry = metadata[index];
                    childUserData.__jsonSourceKey = (_a = metadataEntry === null || metadataEntry === void 0 ? void 0 : metadataEntry.key) !== null && _a !== void 0 ? _a : null;
                    childUserData.__jsonSourceParent = (_c = (_b = parent.group) === null || _b === void 0 ? void 0 : _b.uuid) !== null && _c !== void 0 ? _c : null;
                });
            }
            else {
                for (let index = 0; index < created.length; index += 1) {
                    const child = created[index];
                    if (!child.group)
                        continue;
                    if (!parent.childOrbsManaged.includes(child)) {
                        parent.childOrbsManaged.push(child);
                    }
                    if (parent.group) {
                        parent.addDependent(child.group.uuid);
                        child.addDependency(parent.group.uuid);
                    }
                    const metadataEntry = metadata[index];
                    const childUserData = child.group.userData;
                    childUserData.__jsonSourceKey = (_f = metadataEntry === null || metadataEntry === void 0 ? void 0 : metadataEntry.key) !== null && _f !== void 0 ? _f : null;
                    childUserData.__jsonSourceParent = (_h = (_g = parent.group) === null || _g === void 0 ? void 0 : _g.uuid) !== null && _h !== void 0 ? _h : null;
                }
            }
            userData[JSON_EXPANSION_METADATA_KEY] = metadata;
            if (shouldSpray) {
                const sprayDirection = new THREE.Vector3(0, 0, 1);
                const sprayCoefficient = Math.max(baseRadius * 2.1, 1200);
                const baseVelocity = Math.max(5, baseRadius * 0.06);
                yield SpraySystem.sprayOrbsRefactored(centre.clone(), sprayDirection, created, {
                    scene,
                    originAttachment: parent,
                    sprayCoefficient,
                    baseVelocity,
                });
            }
            return { created };
        });
    }
    extractJsonEntries(rawData) {
        if (Array.isArray(rawData)) {
            return rawData.map((value, index) => [String(index), value]);
        }
        if (!rawData || typeof rawData !== 'object') {
            return [];
        }
        const record = rawData;
        const keys = Object.keys(record).filter(key => !key.startsWith('__'));
        if (keys.length === 0) {
            return [];
        }
        const wrapperCandidates = new Set(['json', 'data', 'payload', 'fields']);
        if (keys.length === 1) {
            const soleKey = keys[0];
            const soleValue = record[soleKey];
            if (soleValue &&
                typeof soleValue === 'object' &&
                !Array.isArray(soleValue) &&
                (wrapperCandidates.has(soleKey) || Object.keys(record).length === 1)) {
                return Object.entries(soleValue).filter(([innerKey]) => !innerKey.startsWith('__'));
            }
            if (Array.isArray(soleValue)) {
                return soleValue.map((value, index) => [String(index), value]);
            }
        }
        return keys.map(key => [key, record[key]]);
    }
    buildJsonChildLabel(key, value) {
        if (value && typeof value === 'object') {
            if (!Array.isArray(value)) {
                const record = value;
                const candidates = ['label', 'name', 'title'];
                for (const candidate of candidates) {
                    const found = record[candidate];
                    if (typeof found === 'string' && found.trim().length > 0) {
                        return found;
                    }
                }
            }
        }
        if (typeof value === 'string' && value.trim().length > 0) {
            return value;
        }
        if (typeof value === 'number' || typeof value === 'boolean') {
            return `${key}: ${value}`;
        }
        if (Array.isArray(value)) {
            return `${key} (${value.length})`;
        }
        return key;
    }
    buildJsonChildData(key, value, parent) {
        var _a, _b, _c;
        const parentLabel = parent.labelText || parent.orbType || ((_a = parent.group) === null || _a === void 0 ? void 0 : _a.uuid) || 'orb';
        const clonedValue = this.cloneJsonValue(value);
        return {
            key,
            value: clonedValue,
            valueType: Array.isArray(value) ? 'array' : typeof value,
            __sourceKey: key,
            __sourceParent: parentLabel,
            __sourceParentId: (_c = (_b = parent.group) === null || _b === void 0 ? void 0 : _b.uuid) !== null && _c !== void 0 ? _c : null,
        };
    }
    cloneJsonValue(value) {
        if (value === null)
            return null;
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return value;
        }
        if (Array.isArray(value)) {
            return value.map(entry => this.cloneJsonValue(entry));
        }
        if (typeof value === 'object') {
            const record = value;
            const clone = {};
            for (const [k, v] of Object.entries(record)) {
                clone[k] = this.cloneJsonValue(v);
            }
            return clone;
        }
        return value;
    }
    activateOrb(eventCoords) {
        console.log("Activating orb...");
        const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
        if (now - this.lastActivateAt < AbilitySystem.ORB_ACTIVATE_COOLDOWN_MS) {
            return;
        }
        const object = SelectionUtils.setSelectedObject(eventCoords);
        if (!object || !object.parent)
            return;
        SelectionUtils.flashOutlineForObject(object);
        //TODO make this happen on all onActivate actions for a brief moment
        //SelectionUtils.applyOutlineToObject(object, '#16f26a', 3)
        const orb = global.orbManager.getOrb(object.parent.uuid);
        if (!orb) {
            global.chat.addMessage("⚠️ No orb found for: " + object.name);
            return;
        }
        // Log + chat feedback
        global.chat.addMessage("✨ Activated: " + object.parent.uuid);
        // 🔥 Trigger all 'onClick' actions registered on this orb
        orb.runAction('onActivate');
        this.lastActivateAt = now;
        //TODO make this happen on all onActivate actions for a brief moment
        //SelectionUtils.clearOutline();
    }
    castSpell(eventCoords) {
        console.log("Casting spell...");
        const object = SelectionUtils.setSelectedObject(eventCoords);
        if (!object)
            return;
        SelectionUtils.applyOutlineToObject(object, '#ff00ff', 5); // Magenta aura
        // TODO: Could add particles or transformation
    }
    hookOrb(eventCoords) {
        console.log("Hooking orb...");
        const object = SelectionUtils.setSelectedObject(eventCoords);
        if (!object)
            return;
        // TODO: Drag the orb to player over time
    }
    userSelectOrb(eventCoords) {
        console.log("User selection in progress...");
        const object = SelectionUtils.setSelectedObject(eventCoords);
        if (!object)
            return;
        global.chat.addMessage(`🖱️ Selected: ${object.name}`);
    }
    warpDimension() {
        const modalId = 'warp-dimension-modal';
        const registry = global.worldRegistry;
        const entries = this.listWarpDimensionEntries();
        openModal({ id: modalId, title: 'Warp Dimension', width: 520, onClose: () => {
                var _a, _b;
                if (!global.controls.isLocked)
                    (_b = (_a = global.controls).lock) === null || _b === void 0 ? void 0 : _b.call(_a);
            } }, container => {
            var _a, _b;
            (_b = (_a = global.controls).unlock) === null || _b === void 0 ? void 0 : _b.call(_a);
            const input = document.createElement('input');
            input.type = 'text';
            input.placeholder = 'Type to filter scenes or worlds…';
            input.className = 'oe-input';
            const list = document.createElement('div');
            list.className = 'oe-palette-list';
            const render = (value) => {
                list.innerHTML = '';
                const term = value.trim().toLowerCase();
                entries
                    .filter(entry => {
                    if (!term)
                        return true;
                    if (entry.kind === 'world') {
                        return (entry.label.toLowerCase().includes(term) ||
                            entry.slug.toLowerCase().includes(term) ||
                            entry.sceneName.toLowerCase().includes(term));
                    }
                    return entry.sceneName.toLowerCase().includes(term);
                })
                    .forEach(entry => {
                    const item = document.createElement('div');
                    item.className = 'oe-palette-item';
                    if (entry.kind === 'world') {
                        item.innerHTML = `<strong>${entry.label}</strong><br/><small>/${entry.slug} • ${entry.sceneName}</small>`;
                        item.addEventListener('click', () => {
                            registry.ensureScene(entry.slug);
                            Portals.switchScene(entry.sceneName, { unloadTwoHops: false });
                            global.chat.addMessage(`🌍 Warped to ${entry.label}`);
                            closeModal(modalId);
                        });
                    }
                    else {
                        item.textContent = entry.sceneName;
                        item.addEventListener('click', () => {
                            Portals.switchScene(entry.sceneName, { unloadTwoHops: false });
                            global.chat.addMessage(`🌍 Warped to ${entry.sceneName}`);
                            closeModal(modalId);
                        });
                    }
                    list.appendChild(item);
                });
            };
            input.addEventListener('input', () => render(input.value));
            container.appendChild(input);
            container.appendChild(list);
            render('');
            window.setTimeout(() => input.focus(), 0);
        });
    }
    listWarpDimensionEntries() {
        const registry = global.worldRegistry;
        const manager = SceneManager.getInstance();
        const worldEntries = registry
            .listWorlds({ includeDynamic: true })
            .map(world => {
            var _a;
            return ({
                kind: 'world',
                slug: world.slug,
                label: (_a = world.label) !== null && _a !== void 0 ? _a : world.slug,
                sceneName: world.sceneName,
            });
        });
        const strayScenes = manager
            .listScenes()
            .filter(scene => !worldEntries.some(entry => entry.sceneName === scene))
            .map(scene => ({ kind: 'scene', sceneName: scene }));
        return [...worldEntries, ...strayScenes];
    }
    toggleAutofly() {
        global.autofly.active = !global.autofly.active;
        if (global.autofly.active) {
            console.log('[AbilitySystem] Autofly engaged', { speed: global.autofly.speed });
            global.chat.addMessage('🛸 Autofly engaged');
        }
        else {
            console.log('[AbilitySystem] Autofly disengaged');
            global.chat.addMessage('🛑 Autofly disengaged');
        }
    }
    repelOrbs() {
        console.log("Repelling nearby orbs...");
        global.orbManager['orbArray'].forEach(orb => {
            const diff = orb.group.position.clone().sub(global.camera.position).normalize();
            orb.addVelocity(diff.multiplyScalar(2.5));
        });
    }
    openCodeWorkbench() {
        const modalId = 'code-workbench-modal';
        const sampleLines = [
            'function greet(name: string) {',
            '  const message = `Hello, ${name}!`;',
            '  console.log(message);',
            '  return message;',
            '}',
            '',
            'export default greet;'
        ];
        const sample = sampleLines.join('\n');
        openModal({ id: modalId, title: 'Code Workbench Prototype', width: 780, onClose: () => {
                var _a, _b;
                if (!global.controls.isLocked)
                    (_b = (_a = global.controls).lock) === null || _b === void 0 ? void 0 : _b.call(_a);
            } }, container => {
            var _a, _b;
            (_b = (_a = global.controls).unlock) === null || _b === void 0 ? void 0 : _b.call(_a);
            container.classList.add('oe-two-column');
            const editor = document.createElement('textarea');
            editor.value = sample;
            editor.rows = 18;
            editor.spellcheck = false;
            editor.className = 'oe-textarea';
            const preview = document.createElement('pre');
            preview.textContent = sample;
            preview.className = 'oe-code-preview';
            editor.addEventListener('input', () => {
                preview.textContent = editor.value;
            });
            container.appendChild(editor);
            container.appendChild(preview);
            window.setTimeout(() => editor.focus(), 0);
        });
    }
    openCommandConsole() {
        var _a, _b;
        const existing = document.getElementById('command-console-panel');
        if (existing === null || existing === void 0 ? void 0 : existing.__dispose) {
            existing.__dispose();
            return;
        }
        beginUiOverlay();
        (_b = (_a = global.controls).unlock) === null || _b === void 0 ? void 0 : _b.call(_a);
        const panel = document.createElement('div');
        panel.id = 'command-console-panel';
        panel.className = 'oe-command-console';
        const header = document.createElement('div');
        header.className = 'oe-command-console__header';
        header.textContent = 'Command Console';
        panel.appendChild(header);
        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'oe-command-console__close';
        closeButton.innerText = '×';
        const dispose = () => {
            var _a, _b;
            if (panel.parentElement) {
                panel.remove();
            }
            endUiOverlay();
            if (!global.controls.isLocked) {
                try {
                    (_b = (_a = global.controls).lock) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
                catch (error) {
                    console.warn('[Console] Failed to relock pointer', error);
                }
            }
            document.removeEventListener('keydown', handleEscape);
        };
        panel.__dispose = dispose;
        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                dispose();
            }
        };
        closeButton.addEventListener('click', dispose);
        document.addEventListener('keydown', handleEscape);
        panel.appendChild(closeButton);
        const output = document.createElement('div');
        output.className = 'oe-console-output';
        panel.appendChild(output);
        const inputRow = document.createElement('div');
        inputRow.className = 'oe-console-input-row';
        const input = document.createElement('input');
        input.type = 'text';
        input.placeholder = 'Enter command…';
        input.className = 'oe-input';
        const submit = document.createElement('button');
        submit.type = 'button';
        submit.textContent = 'Run';
        submit.className = 'primary';
        const run = () => {
            const text = input.value.trim();
            if (!text)
                return;
            const line = document.createElement('div');
            line.textContent = '> ' + text;
            output.appendChild(line);
            input.value = '';
            output.scrollTop = output.scrollHeight;
        };
        submit.addEventListener('click', run);
        input.addEventListener('keydown', ev => {
            if (ev.key === 'Enter')
                run();
        });
        inputRow.appendChild(input);
        inputRow.appendChild(submit);
        panel.appendChild(inputRow);
        document.body.appendChild(panel);
        window.setTimeout(() => input.focus(), 0);
    }
    createCustomOrb() {
        const modalId = 'create-custom-orb-modal';
        const types = Object.keys(OrbTypes);
        openModal({ id: modalId, title: 'Create Custom Orb', width: 680, onClose: () => {
                var _a, _b;
                if (!global.controls.isLocked)
                    (_b = (_a = global.controls).lock) === null || _b === void 0 ? void 0 : _b.call(_a);
            } }, container => {
            var _a, _b;
            (_b = (_a = global.controls).unlock) === null || _b === void 0 ? void 0 : _b.call(_a);
            const select = document.createElement('select');
            select.className = 'oe-input';
            types.forEach(type => {
                const option = document.createElement('option');
                option.value = type;
                option.textContent = type;
                select.appendChild(option);
            });
            const label = document.createElement('input');
            label.placeholder = 'Label';
            label.className = 'oe-input';
            const jsonArea = document.createElement('textarea');
            jsonArea.rows = 8;
            jsonArea.placeholder = '{\n  "description": "..."\n}';
            jsonArea.className = 'oe-textarea';
            const semantic = document.createElement('input');
            semantic.placeholder = 'Semantic tags (comma separated)';
            semantic.className = 'oe-input';
            const submit = document.createElement('button');
            submit.textContent = 'Create Orb';
            submit.className = 'primary';
            submit.addEventListener('click', () => {
                let json = {};
                if (jsonArea.value.trim()) {
                    try {
                        json = JSON.parse(jsonArea.value);
                    }
                    catch (err) {
                        global.chat.addMessage('⚠️ Invalid JSON payload for orb.');
                        return;
                    }
                }
                const orb = OrbFactory.createOrbByType(select.value, label.value || select.value, json);
                if (!orb) {
                    global.chat.addMessage('⚠️ Unable to create orb with that type.');
                    return;
                }
                orb.setPosition(global.camera.position.clone());
                orb.addToScene(global.scene);
                const tags = semantic.value.split(',').map(s => s.trim()).filter(Boolean);
                if (tags.length)
                    global.setSemanticContext(tags);
                global.chat.addMessage(`🧪 Custom orb created (${select.value}).`);
                closeModal(modalId);
            });
            container.appendChild(select);
            container.appendChild(label);
            container.appendChild(jsonArea);
            container.appendChild(semantic);
            container.appendChild(submit);
            window.setTimeout(() => label.focus(), 0);
        });
    }
    //TODO, this should summon a copy of whatever orb is clicked. orbs are supposed to be infinite dimensional so they should be able to be multi-faceted/duplicate within the same space
    openGlobalOrbSearch() {
        const modalId = 'global-orb-search';
        const orbs = global.orbManager.getAllOrbs().map(orb => {
            var _a, _b, _c;
            return ({
                orb,
                label: orb.labelText || orb.orbType || ((_a = orb.group) === null || _a === void 0 ? void 0 : _a.uuid) || 'Orb',
                type: (_b = orb.orbType) !== null && _b !== void 0 ? _b : 'Unknown',
                scene: (_c = global.orbManager.getSceneForOrb(orb)) !== null && _c !== void 0 ? _c : 'unattached'
            });
        });
        openModal({ id: modalId, title: 'Global Orb Search', width: 640, onClose: () => {
                var _a, _b;
                if (!global.controls.isLocked)
                    (_b = (_a = global.controls).lock) === null || _b === void 0 ? void 0 : _b.call(_a);
            } }, container => {
            var _a, _b;
            (_b = (_a = global.controls).unlock) === null || _b === void 0 ? void 0 : _b.call(_a);
            const input = document.createElement('input');
            input.type = 'text';
            input.placeholder = 'Filter orbs by label, type, or scene…';
            input.className = 'oe-input';
            const list = document.createElement('div');
            list.className = 'oe-palette-list';
            const render = (query) => {
                list.innerHTML = '';
                const term = query.trim().toLowerCase();
                orbs
                    .filter(info => !term || (info.label + ' ' + info.type + ' ' + info.scene).toLowerCase().includes(term))
                    .sort((a, b) => {
                    const aPinned = a.type === 'CLIENT_ORB' || a.type === 'CLIENT_STATE_ORB' ? 1 : 0;
                    const bPinned = b.type === 'CLIENT_ORB' || b.type === 'CLIENT_STATE_ORB' ? 1 : 0;
                    if (aPinned !== bPinned)
                        return bPinned - aPinned;
                    return a.label.localeCompare(b.label);
                })
                    .slice(0, 100)
                    .forEach(info => {
                    const item = document.createElement('div');
                    item.className = 'oe-palette-item';
                    item.innerHTML = '<strong>' + info.label + '</strong><br/><small>' + info.type + ' • ' + info.scene + '</small>';
                    item.addEventListener('click', () => {
                        const sceneManager = SceneManager.getInstance();
                        const activeSceneName = sceneManager.getCurrentSceneName();
                        const orbScene = info.orb.group ? global.orbManager.getSceneForOrb(info.orb) : undefined;
                        const playerPosition = global.camera.getWorldPosition(new THREE.Vector3());
                        const forward = global.camera.getWorldDirection(new THREE.Vector3()).normalize();
                        if (info.orb.group && orbScene === activeSceneName) {
                            info.orb.setPosition(playerPosition);
                            global.orbManager.addOrbToScene(info.orb, activeSceneName);
                            global.chat.addMessage(`📍 Moved ${info.label} to your location.`);
                            closeModal(modalId);
                            return;
                        }
                        if (!orbScene || orbScene !== activeSceneName) {
                            const clone = this.cloneOrbForGlobalSearch(info.orb);
                            if (clone) {
                                const spawnPosition = playerPosition.clone().add(forward.multiplyScalar(600));
                                clone.setPosition(spawnPosition);
                                global.orbManager.loadOrb(clone);
                                global.orbManager.addOrbToScene(clone, activeSceneName);
                                const sceneNote = orbScene && orbScene !== activeSceneName ? ` from ${orbScene}` : '';
                                global.chat.addMessage(`✨ Cloned ${info.label}${sceneNote} into ${activeSceneName}.`);
                            }
                            else {
                                global.chat.addMessage(`⚠️ Unable to clone ${info.label}.`);
                            }
                            closeModal(modalId);
                            return;
                        }
                        global.orbManager.addOrbToScene(info.orb, activeSceneName);
                        global.chat.addMessage('🎯 Focused ' + info.label + (activeSceneName ? ` (${activeSceneName})` : ''));
                        closeModal(modalId);
                    });
                    list.appendChild(item);
                });
            };
            input.addEventListener('input', () => render(input.value));
            container.appendChild(input);
            container.appendChild(list);
            render('');
            window.setTimeout(() => input.focus(), 0);
        });
    }
    // TODO: integrate with the clone logic bound to global orb search into one shared cloning utility with a simple interface
    cloneOrbForGlobalSearch(source) {
        return this.cloneOrbWithOverrides(source);
    }
    cloneOrbWithOverrides(source, overrides = {}) {
        var _a, _b, _c;
        const label = (_a = overrides.labelText) !== null && _a !== void 0 ? _a : source.labelText;
        const baseData = (_c = (_b = overrides.jsonData) !== null && _b !== void 0 ? _b : source.jsonData) !== null && _c !== void 0 ? _c : {};
        const dataCopy = this.deepClone(baseData);
        let clone;
        if (source.orbType) {
            clone = OrbFactory.createOrbByType(source.orbType, label, dataCopy);
        }
        if (!clone && source.orbConfig) {
            const _d = source.orbConfig, { layers = [], text: _text } = _d, rest = __rest(_d, ["layers", "text"]);
            const configCopy = Object.assign(Object.assign({}, rest), { layers: layers.map(layer => (Object.assign({}, layer))) });
            clone = new Orb(configCopy, dataCopy, label);
            clone.orbType = source.orbType;
        }
        if (!clone)
            return undefined;
        if (overrides.radius !== undefined && clone.orbConfig) {
            clone.orbConfig = Object.assign(Object.assign({}, clone.orbConfig), { radius: overrides.radius });
        }
        return clone;
    }
    applyDagLayout() {
        console.warn('[AbilitySystem] ApplyDagLayout ability not yet implemented.');
    }
    growSelectedOrb(eventCoords) {
        this.resizeSelectedOrb('grow', eventCoords);
    }
    shrinkSelectedOrb(eventCoords) {
        this.resizeSelectedOrb('shrink', eventCoords);
    }
    // TODO: integrate with the clone logic bound to global orb search into one shared cloning utility with a simple interface
    cloneOrb(eventCoords) {
        var _a, _b, _c, _d;
        const type = global.hudLastSelectedOrbType;
        if (!type || type === '—') {
            global.chat.addMessage('⚠️ Select an orb to clone first.');
            return;
        }
        const reference = this.getReferenceOrbForType(type, eventCoords);
        if (!reference) {
            global.chat.addMessage(`⚠️ No reference orb of type ${type} available to clone.`);
            return;
        }
        let dataCopy = {};
        if (reference.jsonData && Object.keys(reference.jsonData).length > 0) {
            try {
                dataCopy = JSON.parse(JSON.stringify(reference.jsonData));
            }
            catch (error) {
                console.warn('[AbilitySystem] Failed to copy jsonData for cloneOrb', error);
            }
        }
        const label = reference.labelText || reference.orbType || type;
        const orb = OrbFactory.createOrbByType(type, label, dataCopy);
        if (!orb) {
            global.chat.addMessage(`⚠️ Unable to clone a ${type} orb right now.`);
            return;
        }
        if (reference.relationships && reference.relationships.length > 0) {
            const relationshipsCopy = reference.relationships.map(rel => (Object.assign({}, rel)));
            orb.relationships = relationshipsCopy;
            if (orb.orbConfig) {
                orb.orbConfig = Object.assign(Object.assign({}, orb.orbConfig), { relationships: relationshipsCopy });
            }
        }
        const cameraPosition = new THREE.Vector3();
        global.camera.getWorldPosition(cameraPosition);
        const forward = global.camera.getWorldDirection(new THREE.Vector3());
        const spawnDistance = Math.max(((_d = (_b = (_a = reference.orbConfig) === null || _a === void 0 ? void 0 : _a.radius) !== null && _b !== void 0 ? _b : (_c = orb.orbConfig) === null || _c === void 0 ? void 0 : _c.radius) !== null && _d !== void 0 ? _d : 160) * 3, 400);
        const spawnPosition = cameraPosition.clone().add(forward.multiplyScalar(spawnDistance));
        orb.setPosition(spawnPosition);
        orb.addToScene(global.scene);
        global.chat.addMessage(`✨ Cloned ${label} ahead of you.`);
    }
    resizeSelectedOrb(direction, eventCoords) {
        var _a, _b;
        const object = SelectionUtils.setSelectedObject(eventCoords);
        if (!object) {
            global.chat.addMessage('Select an orb to adjust its size.');
            return;
        }
        const orb = this.findOwningOrb(object);
        if (!orb || !orb.orbConfig) {
            global.chat.addMessage('Select a valid orb to resize.');
            return;
        }
        const settings = AbilitySystem.ORB_RESIZE_SETTINGS;
        const label = orb.labelText || orb.orbType || 'Orb';
        const currentRadius = (_a = orb.orbConfig.radius) !== null && _a !== void 0 ? _a : orb.getEffectiveRadius();
        if (!isFinite(currentRadius) || currentRadius <= 0) {
            global.chat.addMessage(`⚠️ Unable to resize ${label}; invalid radius.`);
            this.flashResizeOutline(object, settings.blockedOutlineColor, settings.outlineThickness);
            return;
        }
        const configMin = orb.orbConfig.minRadius;
        const minRadius = Math.max(0.001, Math.min(currentRadius, configMin !== null && configMin !== void 0 ? configMin : settings.minRadius));
        const delta = direction === 'grow' ? settings.delta : -settings.delta;
        let targetRadius = currentRadius + delta;
        let clamped = false;
        if (direction === 'shrink') {
            if (targetRadius < minRadius) {
                targetRadius = minRadius;
                clamped = true;
            }
            if (targetRadius <= 0) {
                targetRadius = minRadius;
                clamped = true;
            }
        }
        if (Math.abs(targetRadius - currentRadius) < 1e-6) {
            const message = clamped
                ? `⚠️ ${label} is already at the minimum radius (${Math.round(minRadius)}).`
                : `ℹ️ ${label} radius unchanged.`;
            global.chat.addMessage(message);
            this.flashResizeOutline(object, settings.blockedOutlineColor, settings.outlineThickness);
            return;
        }
        const rebuildThreshold = (_b = orb.orbConfig.resizeRebuildRatio) !== null && _b !== void 0 ? _b : settings.rebuildThresholdRatio;
        const result = orb.applyRadiusChange(targetRadius, { rebuildThresholdRatio: rebuildThreshold });
        if (!result.changed) {
            global.chat.addMessage(`ℹ️ ${label} radius unchanged.`);
            this.flashResizeOutline(object, settings.blockedOutlineColor, settings.outlineThickness);
            return;
        }
        const newRadius = result.radius;
        const previousRadius = result.previousRadius;
        const deltaApplied = newRadius - previousRadius;
        const deltaText = deltaApplied >= 0 ? `+${Math.round(deltaApplied)}` : `${Math.round(deltaApplied)}`;
        const rebuildSuffix = result.rebuilt ? ' (rebuilt layers)' : '';
        const clampSuffix = clamped ? ' (minimum)' : '';
        const emoji = direction === 'grow' ? '🟢' : '🟠';
        global.chat.addMessage(`${emoji} ${label} radius ${Math.round(previousRadius)} → ${Math.round(newRadius)} (${deltaText})${clampSuffix}${rebuildSuffix}.`);
        const outlineColor = direction === 'grow'
            ? settings.growOutlineColor
            : clamped
                ? settings.blockedOutlineColor
                : settings.shrinkOutlineColor;
        this.flashResizeOutline(object, outlineColor, settings.outlineThickness);
    }
    flashResizeOutline(object, color, thickness) {
        SelectionUtils.applyOutlineToObject(object, color, thickness);
        if (this.resizeOutlineTimeout !== null) {
            window.clearTimeout(this.resizeOutlineTimeout);
        }
        this.resizeOutlineTimeout = window.setTimeout(() => {
            SelectionUtils.clearOutline();
            this.resizeOutlineTimeout = null;
        }, AbilitySystem.ORB_RESIZE_SETTINGS.outlineFlashMs);
    }
    randomWarp() {
        const dimensionEntries = this.listWarpDimensionEntries();
        const orbs = global.orbManager.getAllOrbs();
        const previousPosition = global.controls.getObject().position.clone();
        const dimensionCount = dimensionEntries.length;
        const orbCount = orbs.length;
        const total = dimensionCount + orbCount;
        if (total === 0) {
            global.chat.addMessage('⚠️ No destinations available for random warp.');
            return;
        }
        const choice = Math.floor(Math.random() * total);
        if (choice < dimensionCount) {
            this.randomWarpToDimension(dimensionEntries[choice], previousPosition);
            return;
        }
        const orbIndex = choice - dimensionCount;
        if (orbIndex < 0 || orbIndex >= orbCount) {
            console.warn('[AbilitySystem] Random warp orb index out of bounds', {
                choice,
                dimensionCount,
                orbCount,
            });
            global.chat.addMessage('⚠️ Random warp failed to choose an orb destination.');
            return;
        }
        this.randomWarpToOrb(orbs[orbIndex], previousPosition);
    }
    randomWarpToDimension(entry, previousPosition) {
        const registry = global.worldRegistry;
        if (entry.kind === 'world') {
            registry.ensureScene(entry.slug);
            Portals.switchScene(entry.sceneName, { unloadTwoHops: false });
            this.restorePlayerPosition(previousPosition);
            global.chat.addMessage(`🌍 Random warp → ${entry.label}`);
            return;
        }
        Portals.switchScene(entry.sceneName, { unloadTwoHops: false });
        this.restorePlayerPosition(previousPosition);
        global.chat.addMessage(`🌌 Random warp → scene ${entry.sceneName}`);
    }
    randomWarpToOrb(orb, previousPosition) {
        var _a, _b, _c, _d;
        if (!orb) {
            global.chat.addMessage('⚠️ Unable to locate an orb for random warp.');
            return;
        }
        if (!orb.group) {
            console.warn('[AbilitySystem] Random warp skipped orb without group', {
                orbType: orb.orbType,
                orbGroupUuid: (_a = orb.group) === null || _a === void 0 ? void 0 : _a.uuid,
            });
            global.chat.addMessage('⚠️ Selected orb is not ready for random warp.');
            return;
        }
        try {
            if (((_b = orb.orbConfig) === null || _b === void 0 ? void 0 : _b.isPortal) && ((_c = orb.orbConfig) === null || _c === void 0 ? void 0 : _c.portalTargetSceneName)) {
                Portals.enterPortal(orb);
                this.restorePlayerPosition(previousPosition);
                global.chat.addMessage(`🌀 Random warp → portal ${this.describeOrb(orb)}`);
                return;
            }
            const { sceneName, label } = this.ensureOrbWorldScene(orb);
            Portals.switchScene(sceneName, { unloadTwoHops: false });
            this.restorePlayerPosition(previousPosition);
            global.chat.addMessage(`🪐 Random warp → orb ${label}`);
        }
        catch (error) {
            console.error('[AbilitySystem] Random warp orb entry failed', error, {
                orbType: orb.orbType,
                orbGroupUuid: (_d = orb.group) === null || _d === void 0 ? void 0 : _d.uuid,
            });
            global.chat.addMessage('⚠️ Random warp failed to enter the orb world.');
        }
    }
    restorePlayerPosition(position) {
        global.controls.getObject().position.copy(position);
        global.camera.position.copy(position);
    }
    describeOrb(orb) {
        var _a, _b, _c, _d;
        const label = (_a = orb.labelText) === null || _a === void 0 ? void 0 : _a.trim();
        if (label)
            return label;
        if (orb.orbType)
            return orb.orbType;
        if ((_b = orb.group) === null || _b === void 0 ? void 0 : _b.name)
            return orb.group.name;
        return (_d = (_c = orb.group) === null || _c === void 0 ? void 0 : _c.uuid) !== null && _d !== void 0 ? _d : 'orb';
    }
    toggleOrbSetInversion() {
        /*
         * Orb Set Inversion ability (high-level pseudo-code)
         * 1. Determine which orb world scene is active via SceneManager.getCurrentSceneName() and the
         *    metadata written by ensureOrbWorldScene so we know which orb owns the scene.
         * 2. Gather the related orbs depending on the inversion direction:
         *    • When entering the superset view, walk dependencyOrbs breadth-first to find ancestor orbs,
         *      grouping them by depth to recreate concentric rings similar to buildWorldFromOrb but inverted.
         *    • When returning to the subset view, restore the cached subset scene graph or rebuild it using
         *      buildWorldFromOrb if the cached graph has been disposed.
         * 3. Rebuild the scene contents to visualize the new orientation:
         *    • Remove and cache the active subset root before constructing the superset graph so it can be
         *      reattached later without reloading the entire world.
         *    • Create a new THREE.Group root, add a central wireframe shell for the active orb, then instantiate
         *      ancestor shells with labels and dashed connectors using computeRingLayout to space them evenly.
         *    • Track every generated object in scene.userData to simplify cleanup and allow disposeSupersetRoot
         *      to release geometries, materials, and textures when switching back.
         * 4. Mirror the legacy invert-orb-direction behavior by flipping orbit/connection orientation (e.g.,
         *    reversing Relationship arrows) whenever the superset graph is active, restoring them when the
         *    subset graph returns so both features remain synchronized.
         * 5. Update scene metadata (__orbWorldViewMode, cached roots, etc.) and HUD/chat messaging so repeated
         *    activations simply toggle between subset and superset without leaking resources or confusing the
         *    user about the current state.
         */
        global.orbSetInversionActive = !global.orbSetInversionActive;
        global.hudOrbSetInversionState = global.orbSetInversionActive
            ? 'Superset'
            : 'Subset';
        global.hudDirty.orbSetInversionState = true;
        const message = global.orbSetInversionActive
            ? 'Orb set inversion toggled on (implementation pending).'
            : 'Orb set inversion toggled off (implementation pending).';
        global.chat.addMessage(message);
    }
    splitOrb(eventCoords) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: Remove this ability once JSON field expansion is unified into a single toggle.
            const object = SelectionUtils.setSelectedObject(eventCoords);
            if (!object || !object.parent) {
                global.chat.addMessage('⚠️ Select an orb to split its JSON fields.');
                return;
            }
            const orb = global.orbManager.getOrb(object.parent.uuid);
            if (!orb) {
                global.chat.addMessage('⚠️ Could not resolve an orb to split.');
                return;
            }
            const result = yield this.expandJsonDataChildren(orb, { spawnStyle: 'spray' });
            if (result.created.length > 0) {
                const plural = result.created.length === 1 ? '' : 's';
                global.chat.addMessage(`✨ Split ${result.created.length} JSON field${plural} into child orbs.`);
                return;
            }
            switch (result.reason) {
                case 'noData':
                case 'noEntries':
                    global.chat.addMessage('ℹ️ This orb has no JSON fields to split.');
                    break;
                case 'noGroup':
                    global.chat.addMessage('⚠️ Unable to split this orb because it has not been instantiated yet.');
                    break;
                case 'noScene':
                    global.chat.addMessage('⚠️ Unable to determine where to spawn the split JSON fields.');
                    break;
                default:
                    global.chat.addMessage('ℹ️ No child orbs were generated from the JSON data.');
                    break;
            }
        });
    }
    mergeOrbs(eventCoords) {
        var _a, _b;
        const object = SelectionUtils.getTargetObject(eventCoords);
        if (!object || !object.parent) {
            this.clearMergeSelection('🔶 Merge selection cleared.');
            return;
        }
        const orb = global.orbManager.getOrb(object.parent.uuid);
        if (!orb) {
            this.clearMergeSelection('🔶 Merge selection cleared.');
            return;
        }
        if (!this.pendingMergeSelection) {
            this.startMergeSelection(orb, object);
            return;
        }
        if (((_a = this.pendingMergeSelection.orb.group) === null || _a === void 0 ? void 0 : _a.uuid) === ((_b = orb.group) === null || _b === void 0 ? void 0 : _b.uuid)) {
            this.clearMergeSelection('🔶 Merge selection cleared.');
            return;
        }
        const first = this.pendingMergeSelection.orb;
        const success = this.executeOrbMerge(first, orb);
        if (success) {
            SelectionUtils.clearOutline();
            this.pendingMergeSelection = null;
        }
        else {
            // Keep the first selection highlighted so the player can try again.
            if (this.pendingMergeSelection) {
                SelectionUtils.applyOutlineToObject(this.pendingMergeSelection.object, 0x9c27b0, 4);
            }
        }
    }
    startMergeSelection(orb, object) {
        this.pendingMergeSelection = { orb, object };
        SelectionUtils.applyOutlineToObject(object, 0x9c27b0, 4);
        global.chat.addMessage('🟣 First orb selected for merge. Choose another orb to merge with, or click empty space to cancel.');
    }
    clearMergeSelection(message) {
        if (message) {
            global.chat.addMessage(message);
        }
        this.pendingMergeSelection = null;
        SelectionUtils.clearOutline();
    }
    executeOrbMerge(first, second) {
        var _a, _b;
        const firstGroup = first.group;
        const secondGroup = second.group;
        if (!firstGroup || !secondGroup) {
            global.chat.addMessage('⚠️ Unable to merge orbs that are not placed in the world.');
            return false;
        }
        const sceneA = global.orbManager.getSceneForOrb(first);
        const sceneB = global.orbManager.getSceneForOrb(second);
        if (!sceneA || !sceneB || sceneA !== sceneB) {
            global.chat.addMessage('⚠️ Orbs must reside in the same scene to merge.');
            return false;
        }
        const posA = new THREE.Vector3();
        const posB = new THREE.Vector3();
        firstGroup.getWorldPosition(posA);
        secondGroup.getWorldPosition(posB);
        const mergedJson = this.mergeOrbJsonData((_a = first.jsonData) !== null && _a !== void 0 ? _a : {}, (_b = second.jsonData) !== null && _b !== void 0 ? _b : {});
        mergedJson.__mergedFrom = [
            { uuid: firstGroup.uuid, label: this.describeOrbLabel(first) },
            { uuid: secondGroup.uuid, label: this.describeOrbLabel(second) },
        ];
        const radiusA = getEffectiveRadius(first);
        const radiusB = getEffectiveRadius(second);
        const mergedRadius = this.computeCombinedRadius(radiusA, radiusB);
        const label = `${this.describeOrbLabel(first)} + ${this.describeOrbLabel(second)}`;
        const mergedOrb = this.cloneOrbWithOverrides(first, {
            labelText: label,
            jsonData: mergedJson,
            radius: mergedRadius,
        });
        if (!mergedOrb) {
            global.chat.addMessage('⚠️ Failed to create a merged orb from the selected pair.');
            return false;
        }
        const midpoint = posA.clone().lerp(posB, 0.5);
        mergedOrb.setPosition(midpoint);
        const connectionManager = OrbConnectionManager.getInstance();
        connectionManager.disconnectAllFor(first);
        connectionManager.disconnectAllFor(second);
        if (firstGroup.uuid) {
            global.orbManager.hardRemoveOrb(firstGroup.uuid);
        }
        if (secondGroup.uuid) {
            global.orbManager.hardRemoveOrb(secondGroup.uuid);
        }
        global.orbManager.loadOrb(mergedOrb);
        global.orbManager.addOrbToScene(mergedOrb, sceneA);
        const roundedRadius = Math.round(mergedRadius);
        global.chat.addMessage(`🟣 Merged ${this.describeOrbLabel(first)} and ${this.describeOrbLabel(second)} → ${label} (r ≈ ${roundedRadius}).`);
        return true;
    }
    mergeOrbJsonData(a, b) {
        const mergeValues = (left, right) => {
            if (Array.isArray(left) && Array.isArray(right)) {
                return [...left.map(value => this.deepClone(value)), ...right.map(value => this.deepClone(value))];
            }
            if (this.isPlainObject(left) && this.isPlainObject(right)) {
                const result = {};
                const keys = new Set([...Object.keys(left), ...Object.keys(right)]);
                for (const key of keys) {
                    const lVal = left[key];
                    const rVal = right[key];
                    if (lVal !== undefined && rVal !== undefined) {
                        result[key] = mergeValues(lVal, rVal);
                    }
                    else if (lVal !== undefined) {
                        result[key] = this.deepClone(lVal);
                    }
                    else if (rVal !== undefined) {
                        result[key] = this.deepClone(rVal);
                    }
                }
                return result;
            }
            if (left === undefined)
                return this.deepClone(right);
            if (right === undefined)
                return this.deepClone(left);
            if (Object.is(left, right))
                return this.deepClone(left);
            return [this.deepClone(left), this.deepClone(right)];
        };
        return mergeValues(this.deepClone(a !== null && a !== void 0 ? a : {}), this.deepClone(b !== null && b !== void 0 ? b : {}));
    }
    computeCombinedRadius(radiusA, radiusB) {
        const safeA = Math.max(radiusA || 0, 1);
        const safeB = Math.max(radiusB || 0, 1);
        return Math.cbrt(Math.pow(safeA, 3) + Math.pow(safeB, 3));
    }
    describeOrbLabel(orb) {
        var _a;
        return ((_a = orb.labelText) === null || _a === void 0 ? void 0 : _a.trim()) || orb.orbType || 'Orb';
    }
    isPlainObject(value) {
        return value !== null && typeof value === 'object' && !Array.isArray(value);
    }
    deepClone(value) {
        if (Array.isArray(value)) {
            return value.map(item => this.deepClone(item));
        }
        if (this.isPlainObject(value)) {
            const result = {};
            for (const key of Object.keys(value)) {
                result[key] = this.deepClone(value[key]);
            }
            return result;
        }
        return value;
    }
    toggleConnectionPresentation(eventCoords) {
        const object = SelectionUtils.setSelectedObject(eventCoords);
        if (!object) {
            global.chat.addMessage('No orb selected to toggle connection presentation.');
            return;
        }
        const parent = this.findOwningOrb(object);
        if (!parent || !parent.group) {
            global.chat.addMessage('Select an orb to toggle its dependent presentation.');
            return;
        }
        const records = getRegisteredRingChildren(parent);
        if (records.length === 0) {
            global.chat.addMessage('Selected orb has no registered orbiting dependents to toggle.');
            return;
        }
        const current = getRingParentPresentationMode(parent);
        const nextIndex = (CONNECTION_PRESENTATION_ORDER.indexOf(current) + 1) % CONNECTION_PRESENTATION_ORDER.length;
        const nextMode = CONNECTION_PRESENTATION_ORDER[nextIndex];
        setRingParentPresentationMode(parent, nextMode);
        const manager = OrbConnectionManager.getInstance();
        for (const record of records) {
            setRingChildPresentationMode(record.parent, record.child, nextMode);
            this.applyConnectionPresentation(record, nextMode, manager);
        }
        global.chat.addMessage(`Connection presentation → ${this.describePresentationMode(nextMode)}`);
    }
    applyConnectionPresentation(record, mode, manager) {
        const parentGroup = record.parent.group;
        const childGroup = record.child.group;
        if (!parentGroup || !childGroup)
            return;
        record.animator.update(record.binding);
        const profileName = getPresentationProfileName(record.parent, record.child);
        manager.setRelationshipState({
            a: record.parent,
            b: record.child,
            mode,
            profileName,
            profile: Object.assign(Object.assign({}, DEFAULT_PRESENTATION_ARROW_PROFILE), { name: profileName }),
        });
    }
    describePresentationMode(mode) {
        switch (mode) {
            case 'orbitWithArrow':
                return 'Orbit + arrows';
            case 'arrow':
                return 'Arrows only';
            case 'hidden':
                return 'Hidden';
            default:
                return 'Orbit';
        }
    }
    findOwningOrb(obj) {
        let current = obj;
        while (current) {
            const orb = global.orbManager.getOrb(current.uuid);
            if (orb)
                return orb;
            current = current.parent;
        }
        return null;
    }
    getReferenceOrbForType(type, eventCoords) {
        if (eventCoords) {
            const target = SelectionUtils.getTargetObject(eventCoords);
            if (target) {
                const fromPointer = this.findOwningOrb(target);
                if (fromPointer && fromPointer.orbType === type) {
                    return fromPointer;
                }
            }
        }
        if (global.currentObject) {
            const current = this.findOwningOrb(global.currentObject);
            if (current && current.orbType === type) {
                return current;
            }
        }
        const [first] = global.orbManager.getOrbsByType(type);
        return first;
    }
    resolveInteractionObject(eventCoords, options = { allowLocalClientOrbOnBounce: false }) {
        var _a, _b, _c, _d, _e;
        const worldName = ((_a = global.hudCurrentWorld) !== null && _a !== void 0 ? _a : '').toLowerCase();
        const sceneName = ((_d = (_c = (_b = global.sceneManager).getCurrentSceneName) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : '').toLowerCase();
        const inSystemWorld = worldName === 'system' || sceneName.includes('system');
        if (!inSystemWorld) {
            return SelectionUtils.getTargetObjectWithReflectionBounce(eventCoords, options);
        }
        const rect = global.renderer.domElement.getBoundingClientRect();
        const pointer = eventCoords
            ? new THREE.Vector2(((eventCoords.x - rect.left) / rect.width) * 2 - 1, -((eventCoords.y - rect.top) / rect.height) * 2 + 1)
            : new THREE.Vector2(0, 0);
        global.raycaster.setFromCamera(pointer, global.camera);
        const mirrorNormal = new THREE.Vector3(0, 1, 0);
        const cameraPosition = global.camera.getWorldPosition(new THREE.Vector3());
        const cameraDirection = global.camera.getWorldDirection(new THREE.Vector3()).normalize();
        const reflectedCameraPosition = cameraPosition.clone();
        reflectedCameraPosition.y *= -1;
        const reflectedDirection = cameraDirection.clone().reflect(mirrorNormal).normalize();
        const reflectedUp = global.camera.up.clone().reflect(mirrorNormal).normalize();
        const virtualMirrorCamera = new THREE.PerspectiveCamera(global.camera.fov, global.camera.aspect, global.camera.near, global.camera.far);
        virtualMirrorCamera.position.copy(reflectedCameraPosition);
        virtualMirrorCamera.up.copy(reflectedUp);
        virtualMirrorCamera.lookAt(reflectedCameraPosition.clone().add(reflectedDirection));
        virtualMirrorCamera.updateMatrixWorld(true);
        virtualMirrorCamera.updateProjectionMatrix();
        const mirrorRaycaster = new THREE.Raycaster();
        mirrorRaycaster.setFromCamera(pointer, virtualMirrorCamera);
        const hits = mirrorRaycaster.intersectObjects(global.scene.children, true);
        const picked = hits.find((hit) => {
            const obj = hit.object;
            if (this.isReflectiveSelectionSurface(obj))
                return false;
            if (!options.allowLocalClientOrbOnBounce && this.isLocalClientOrbObject(obj))
                return false;
            return true;
        });
        return (_e = picked === null || picked === void 0 ? void 0 : picked.object) !== null && _e !== void 0 ? _e : SelectionUtils.getTargetObjectWithReflectionBounce(eventCoords, options);
    }
    isReflectiveSelectionSurface(object) {
        if (!object)
            return false;
        const anyObj = object;
        if (anyObj.isReflector || anyObj.type === 'Reflector')
            return true;
        if (typeof object.name === 'string' && object.name.toLowerCase().includes('mirror'))
            return true;
        const material = anyObj.material;
        const uniforms = material === null || material === void 0 ? void 0 : material.uniforms;
        return !!(uniforms === null || uniforms === void 0 ? void 0 : uniforms.tDiffuse);
    }
    isLocalClientOrbObject(object) {
        var _a, _b;
        const localClientGroup = (_b = (_a = playerManager.local) === null || _a === void 0 ? void 0 : _a.getOrb()) === null || _b === void 0 ? void 0 : _b.group;
        if (!localClientGroup || !object)
            return false;
        let current = object;
        while (current) {
            if (current.uuid === localClientGroup.uuid)
                return true;
            current = current.parent;
        }
        return false;
    }
    ensureOrbWorldScene(orb) {
        var _a, _b, _c, _d;
        const labelSource = orb.labelText || orb.orbType || 'orb';
        const normalizedLabel = labelSource
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '') || 'orb';
        const existingSlug = typeof ((_b = (_a = orb.group) === null || _a === void 0 ? void 0 : _a.userData) === null || _b === void 0 ? void 0 : _b.__orbWorldSlug) === 'string'
            ? orb.group.userData.__orbWorldSlug
            : undefined;
        const groupId = (_d = (_c = orb.group) === null || _c === void 0 ? void 0 : _c.uuid) !== null && _d !== void 0 ? _d : Date.now().toString(36);
        const idFragment = groupId.replace(/[^a-z0-9]+/gi, '').toLowerCase() || Date.now().toString(36);
        const generatedSlug = `${normalizedLabel}-${idFragment.slice(0, 8)}`.replace(/-+/g, '-');
        if (!generatedSlug || generatedSlug === '-') {
            console.warn('[AbilitySystem] Fallback slug required for orb world', {
                orbLabel: labelSource,
                groupId,
            });
        }
        const slug = existingSlug !== null && existingSlug !== void 0 ? existingSlug : (generatedSlug && generatedSlug !== '-' ? generatedSlug : `orb-${idFragment.slice(0, 8)}`);
        const sceneName = `orb-world-${slug}`.replace(/-+/g, '-');
        let world = global.worldRegistry.getWorld(slug);
        let worldWasCreated = false;
        if (!world) {
            world = new World({
                slug,
                label: labelSource,
                sceneName,
                build: ({ scene }) => {
                    var _a, _b, _c, _d;
                    buildWorldFromOrb(orb, sceneName, scene);
                    const innerColor = (_d = (_c = (_b = (_a = orb.orbConfig) === null || _a === void 0 ? void 0 : _a.layers) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.color) !== null && _d !== void 0 ? _d : 0xb5c7ff;
                    const baseColor = new THREE.Color(innerColor);
                    const backdrop = baseColor.clone().lerp(new THREE.Color('#ffffff'), 0.25);
                    scene.background = backdrop;
                    scene.fog = new THREE.Fog(backdrop, 0, ORB_WORLD_RADIUS * 12);
                    const lightingGroupName = '__orbWorldLighting';
                    const existingLighting = scene.getObjectByName(lightingGroupName);
                    if (existingLighting) {
                        scene.remove(existingLighting);
                    }
                    const lightingGroup = new THREE.Group();
                    lightingGroup.name = lightingGroupName;
                    const ambient = new THREE.HemisphereLight(0xf4f7ff, backdrop.clone().multiplyScalar(0.55), 0.85);
                    const sun = new THREE.DirectionalLight(0xffffff, 0.65);
                    sun.position.set(-1600, 2600, 1800);
                    lightingGroup.add(ambient);
                    lightingGroup.add(sun);
                    scene.add(lightingGroup);
                    const boundaryName = '__orbWorldBoundary';
                    const existingBoundary = scene.getObjectByName(boundaryName);
                    if (existingBoundary) {
                        scene.remove(existingBoundary);
                    }
                    const boundary = addWorldBoundarySphere(scene, ORB_WORLD_RADIUS, {
                        color: baseColor.getHex(),
                        opacity: 0.22,
                        segments: 64,
                    });
                    boundary.name = boundaryName;
                    registerScenePolicy(sceneName, { radius: ORB_WORLD_RADIUS, floorY: 0 });
                },
            });
            global.worldRegistry.registerWorld(world);
            worldWasCreated = true;
        }
        global.worldRegistry.ensureScene(slug, { forceReload: worldWasCreated });
        if (orb.group) {
            const data = orb.group.userData;
            data.__orbWorldScene = world.sceneName;
            data.__orbWorldSlug = slug;
        }
        return { sceneName: world.sceneName, label: world.label };
    }
}
AbilitySystem.ORB_ACTIVATE_COOLDOWN_MS = 1000;
AbilitySystem.ORB_RESIZE_SETTINGS = {
    delta: 25,
    minRadius: 4,
    rebuildThresholdRatio: 1.5,
    growOutlineColor: 0x4caf50,
    shrinkOutlineColor: 0xff7043,
    blockedOutlineColor: 0xff1744,
    outlineThickness: 4,
    outlineFlashMs: 420,
};
